import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import "./AdminBetsRequest.css";

export default function AdminBetsRequest() {
  const [bets, setBets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchMatch, setSearchMatch] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchBets();
  }, []);

  async function fetchBets() {
    setLoading(true);
    try {
      const snapshot = await getDocs(collection(db, "userBets"));
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBets(list);
    } catch (error) {
      console.error("Error fetching bets:", error);
    } finally {
      setLoading(false);
    }
  }

  const showMessage = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), 3000);
  };

  function isPastMatch(bet) {
    try {
      const matchDateTime = new Date(`${bet.matchDate}T${bet.matchTime}`);
      return matchDateTime < new Date();
    } catch {
      return false;
    }
  }

  async function handleWonBet(bet) {
    if (bet.paidOut === true) {
      showMessage(`⚠️ ${bet.username} tayari alishalipwa`);
      return;
    }

    if (!isPastMatch(bet)) {
      showMessage("⚠️ Mechi bado haijachezwa");
      return;
    }

    try {
      await updateDoc(doc(db, "userBets", bet.id), {
        status: "Won",
        paidOut: true,
        paidAt: new Date().toISOString(),
      });

      const userSnap = await getDocs(
        query(collection(db, "users"), where("username", "==", bet.username))
      );

      if (userSnap.empty) return;

      const userDoc = userSnap.docs[0];
      const userData = userDoc.data();

      const tsh = Number(userData.tshBalance || 0);
      const usdt = Number(userData.usdtBalance || 0);

      await updateDoc(userDoc.ref, {
        tshBalance: tsh + (bet.currency === "TSH" ? Number(bet.payout || 0) : 0),
        usdtBalance:
          usdt + (bet.currency === "USDT" ? Number(bet.payout || 0) : 0),
      });

      showMessage(`💰 ${bet.username} amelipwa`);
      fetchBets();
    } catch (e) {
      showMessage("Tatizo limetokea");
    }
  }

  async function updateBetStatus(id, status) {
    await updateDoc(doc(db, "userBets", id), { status });
    fetchBets();
  }

  async function deleteBet(id) {
    await deleteDoc(doc(db, "userBets", id));
    showMessage("Bet imefutwa");
    fetchBets();
  }

  const normalize = (s) => (s || "").toLowerCase().trim();

  const matchLabel = (bet) =>
    `${normalize(bet.teamA)} ${normalize(bet.teamB)} ${normalize(
      bet.username
    )}`;

  const search = normalize(searchMatch);

  // 🔥 HII NDIO SEHEMU MUHIMU ILIYOREKEBISHWA
  const matchingBets = bets
    .filter((bet) => matchLabel(bet).includes(search))
    .sort((a, b) => {
      // 1️⃣ Unpaid kwanza
      if (!a.paidOut && b.paidOut) return -1;
      if (a.paidOut && !b.paidOut) return 1;

      // 2️⃣ Mpya kwanza
      const dateA = new Date(a.betTime || a.matchDate);
      const dateB = new Date(b.betTime || b.matchDate);
      return dateB - dateA;
    });

  const wonBets = bets.filter((b) => b.status === "Won");
  const lostBets = bets.filter((b) => b.status === "Lost");
  const noStatusBets = bets.filter((b) => !b.status);

  const renderTable = (list, title) => (
    <div className="bets-column">
      <h3>{title}</h3>
      <table className="bets-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Match</th>
            <th>Score</th>
            <th>Amount</th>
            <th>Payout</th>
            <th>Status</th>
            <th>Paid</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {list.map((bet) => (
            <tr key={bet.id}>
              <td>{bet.username}</td>
              <td>
                {bet.teamA} vs {bet.teamB}
              </td>
              <td>{bet.selectedScore}</td>
              <td>{bet.betInTsh || bet.betInUsdt}</td>
              <td>{bet.payout}</td>
              <td>{bet.status || "—"}</td>
              <td>{bet.paidOut ? "✔️" : "❌"}</td>
              <td>
                <button onClick={() => handleWonBet(bet)}>Won</button>
                <button onClick={() => updateBetStatus(bet.id, "Lost")}>
                  Lost
                </button>
                <button onClick={() => deleteBet(bet.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div>
      <h2>Admin Bets View</h2>

      <input
        value={searchMatch}
        onChange={(e) => setSearchMatch(e.target.value)}
        placeholder="Tafuta username au mechi"
      />

      {message && <p>{message}</p>}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {renderTable(matchingBets, "🔍 Matokeo ya Search")}
          {renderTable(noStatusBets, "⚠️ Bila Status")}
          {renderTable(wonBets, "✅ Won")}
          {renderTable(lostBets, "❌ Lost")}
        </>
      )}
    </div>
  );
}